import React from 'react';
import PropTypes from 'prop-types';
import { isSet } from '../../../../../../utils/commonUtils'; 

const AdulterationForm = (props) => {
  const {
    label,
    notes,
    className,
    style,
    id,
    name,
    appendClassLabel
  } = props;

  return (
    <div 
      className={`${className}`} 
      style={{ ...style }}
      id={isSet(id, name)}
    >
      <div className="mb-6 px-3">
      <label className={`form-label ${isSet(appendClassLabel, 'font-weight-bold')} pl-1`}>{label}</label>
      <ul className="list-disc ml-6 space-y-1">
              {notes && notes.map((note, index) => (
                <li key={index} className="adulteration-item">
                  {note}
                </li>
              ))}
          </ul>
      </div>
    </div>
  );
};

AdulterationForm.defaultProps = {
  className: 'p-6 bg-white text-dark font-sans',
  label: 'Signs of Adulteration',
  note: 'specimen temperature must be read within 4 minutes of collection.',
  fields: [
    {
      label: 'Signs of adulteration include:',
      notes: ['unusual color', 'unusual smell', 'foreign objects in specimen', 'unusual behavior by donor'],
    }
  ],
  style: {},
};

AdulterationForm.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  note: PropTypes.string,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      notes: PropTypes.arrayOf(PropTypes.string)
    })
  ),
  style: PropTypes.object,
};

export default AdulterationForm;